import React from 'react';

const Organizer: React.FC = () => {
  const events = [
    {
      title: 'DevOpsDays Krakow',
      role: 'Co-organizer',
      description: 'DevOps-focused event in Krakow',
      link: 'https://dodkrakow.pl/'
    },
    {
      title: 'DevOpsDays Warsaw',
      role: 'Co-organizer',
      description: 'DevOps community event in Warsaw',
      link: 'https://devopsdays.pl/'
    },
    {
      title: 'Kubernetes Community Day Warsaw',
      role: 'Co-organizer',
      description: 'CNCF-supported Kubernetes event',
      link: 'https://community.cncf.io/kcd-warsaw'
    },
    {
      title: 'AWS Community Day Poland',
      role: 'Former Co-organizer (till 2025)',
      description: 'Annual AWS-focused community conference in Poland',
      link: 'https://awscommunity.pl'
    },
  ];

  return (
    <div className="page organizer">
      <div className="container">
        <section className="hero-section">
          <img 
            src="/images/20240411_162539.jpg" 
            alt="Pawel Piwosz Organizer" 
            className="organizer-hero-image" 
          />
          <h1>Event Organizer</h1>
        </section>
        
        <div className="intro-text">
          <p>Leading and organizing major tech events in Poland</p>
        </div>

        <div className="events-grid">
          {events.map((event) => (
            <div key={event.title} className="event-card">
              <h2>{event.title}</h2>
              <span className="role">{event.role}</span>
              <p>{event.description}</p>
              <a href={event.link} target="_blank" rel="noopener noreferrer">
                Event Details
              </a>
            </div>
          ))}
        </div>

        <div className="committee-section">
          <h2>Program Committee Member</h2>
          <div className="committee-card">
            <h3>TADA Conference</h3>
            <p>Technical program committee member for Test Automation DevOps Arena</p>
            <a href="https://tada-conf.pl/" target="_blank" rel="noopener noreferrer">
              Learn More
            </a>
          </div>
        </div>

        <div className="meetups-section">
          <h2>Meetups Organizer</h2>
          <div className="meetup-card">
            <h3>Cloud Native Krakow</h3>
            <p>Regular meetup focused on cloud-native technologies, Kubernetes, and modern infrastructure.</p>
            <a href="https://www.meetup.com/cloud-native-krakow/" target="_blank" rel="noopener noreferrer">
              Join the Community
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Organizer;